import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http_auth} from "@utils"
import {toast} from "react-toastify"
import * as auth from "../Auth"
import {REFRESH_TOKEN} from "../../../utility/Utils"

export const getThingById = createAsyncThunk('reference/getThingById', async (thingId, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.get(`/registration/v1/thing/get/${thingId}`)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})
export const lostReferences = createAsyncThunk('reference/lostReferences', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post('/registration/v1/lost/application', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const lostReferencesAll = createAsyncThunk('reference/lostReferencesAll', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post('/registration/v1/lost/application-filter', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const generateLostReport = createAsyncThunk('reference/generateLostReport', async (thingId, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/file/v1/attachment/generate-lost-report/${thingId}`)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const foundReferencesAll = createAsyncThunk('reference/foundReferencesAll', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post('/registration/v1/found/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})


export const referenceSlice = createSlice({
    name: 'reference',
    initialState: {
        lostReferences: [],
        foundReferences: [],
        getThing: {},
        currentPage: 0,
        totalItem: 0,
        totalPages: 0,
        isLoading: false,

        count_item_ref: 0,
        total_count_ref: 0,
        current_page_ref: 0
    },
    reducers: {},
    extraReducers: {
        [foundReferencesAll.fulfilled]: (state, actions) => {
            state.foundReferences = actions.payload?.data
            state.current_page_ref = actions.payload?.page
            state.count_item_ref = actions.payload?.count
            state.total_count_ref = actions.payload?.total_count
            state.isLoading = false
        },
        [foundReferencesAll.pending]: (state) => {
            state.isLoading = true
        },
        [foundReferencesAll.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [lostReferencesAll.fulfilled]: (state, actions) => {
            state.lostReferencesAll = actions.payload?.data
            state.current_page_ref = actions.payload?.page
            state.count_item_ref = actions.payload?.count
            state.total_count_ref = actions.payload?.total_count
            state.isLoading = false
        },
        [lostReferencesAll.pending]: (state) => {
            state.isLoading = true
        },
        [lostReferencesAll.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [lostReferences.fulfilled]: (state, actions) => {
            state.lostReferences = actions.payload
            state.isLoading = false
        },
        [lostReferences.pending]: (state) => {
            state.isLoading = true
        },
        [lostReferences.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getThingById.fulfilled]: (state, actions) => {
            state.getThing[actions.meta?.arg] = actions.payload
            state.isLoading = false
        },
        [getThingById.pending]: (state) => {
            state.isLoading = true
        },
        [getThingById.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        }
    }
})

export const {} = referenceSlice.actions
export default referenceSlice.reducer
